import React, { useState, useRef, useEffect } from "react";
import loadImage from "blueimp-load-image";
import { useParams } from "react-router";
import { useHistory, useLocation } from "react-router-dom";
import Select from "react-select";
import MonthWeekSelect from "../../../components/MonthWeekSelect";
import RadioItem from "../../../components/RadioItem";
import ImageUpload from "../../../components/ContentUpload/ImageUpload";
import VideoUpload from "../../../components/ContentUpload/VideoUpload";
import YoutubeInput from "../../../components/ContentUpload/YoutubeInput";

import { ContentTypes } from "../../../Constants/selections";
import "./index.css";
import {
  GIF_UPLOAD,
  VIDEO_UPLOAD,
  IMAGE_UPLOAD,
  YOUTUBE_URL,
} from "../../../Constants/types";
import { UPLOADING_VIDEO, UPLOADING_IMAGE } from "../../../Constants/string";

import "./index.css";
import Firebase from "../../../firebasehelper";
const EditHotTopic = () => {
  const imgEl = useRef(null);
  const [title, setTitle] = useState("");
  const [img_content, setImageContent] = useState("");
  const [mediaType, setMediaType] = useState(null);
  const [mediaUrl, setMediaUrl] = useState("");
  const [description, setDescription] = useState("");
  const [content, setContent] = useState("");
  const [starting_monday, setStartingMonday] = useState(null);
  const [toMembers, setToMembers] = useState(true);
  const [toReferrals, setToReferrals] = useState(true);
  const [loadingState, setLoadingState] = useState({
    loading: false,
    loading_script: "",
  });
  let history = useHistory();
  const { id } = useParams();
  const { state } = useLocation();

  useEffect(() => {
    loadHotTopic();
  }, []);

  async function loadHotTopic() {
    const { brand_name } = state;
    const hotTopic = await Firebase.getHotTopic(brand_name, id);
    const {
      description,
      image_url,
      title,
      toMembers,
      toReferrals,
      media_type,
      media_url,
    } = hotTopic;
    setDescription(description);
    setTitle(title);
    // setImageContent(image_url);
    setMediaType(ContentTypes.find((type) => type.value === media_type));
    setMediaUrl(media_url || image_url);
    setToMembers(toMembers === undefined || toMembers === true ? true : false);
    setToReferrals(
      toReferrals === undefined || toReferrals === true ? true : false
    );
  }
  function handleInputChange(field, event) {
    if (field === "title") setTitle(event.target.value);
    if (field === "description") setDescription(event.target.value);
  }
  function selectedFile(event) {
    event.stopPropagation();
    event.preventDefault();
    const content = event.target.files[0];
    loadImage.parseMetaData(content, function (data) {
      //default image orientation
      var orientation = 0;
      if (data.exif) {
        orientation = data.exif.get("Orientation");
      }
      loadImage(
        content,
        function (canvas) {
          var base64data = canvas.toDataURL("image/png");
          var img_src = base64data.replace(/^data\:image\/\w+\;base64\,/, "");
          setContent(img_src);
          let img_content = "data:image/jpeg;base64," + img_src;
          setImageContent(img_content);
        },
        {
          canvas: true,
          orientation: orientation,
        }
      );
    });
  }
  function checkValidation() {
    const title_validation = title ? true : false;
    const media_content_validation = mediaType && mediaUrl ? true : false;
    const description_validation = description ? true : false;
    const week_validation = starting_monday ? true : false;
    const validation =
      title_validation &&
      media_content_validation &&
      description_validation &&
      week_validation;
    return validation;
  }
  async function updateHotTopic() {
    let { brand_name } = state;

    let hotTopic = {
      title,
      description,
      starting_monday,
      media_type: mediaType.value,
      media_url: mediaUrl,
      toMembers,
      toReferrals,
    };
    Firebase.updateHotTopic(brand_name, id, hotTopic).then((res) => {
      history.goBack();
    });
  }
  function setWeek(starting_monday) {
    setStartingMonday(starting_monday);
  }
  const handleSelectContentType = (type) => {
    setMediaType(type);
  };

  const handleSetMediaURL = (imgURL) => {
    // const newContent = _.cloneDeep(content);
    // newContent["media_url"] = imgURL;
    // setContent(newContent);
    setMediaUrl(imgURL);
    // modification tracking..
    // let newModification = { ...modification, media_url: imgURL };
    // setModification(newModification);
  };

  const uploadContent = (contentType) => async (mediaContent) => {
    const uploadFolder = "hot-topics/";
    const title = new Date().getTime().toString();
    if (contentType === GIF_UPLOAD) {
      setLoadingState({ loading: true, loading_script: UPLOADING_IMAGE });
      let gif_url = await Firebase.uploadGif(
        mediaContent,
        title,
        uploadFolder + "/gifs"
      );
      setLoadingState({ loading: false, loading_script: "" });
      handleSetMediaURL(gif_url);
    } else if (contentType === IMAGE_UPLOAD) {
      setLoadingState({ loading: true, loading_script: UPLOADING_IMAGE });
      let img_url = await Firebase.uploadImage(
        mediaContent,
        title,
        uploadFolder + "/images"
      );
      setLoadingState({ loading: false, loading_script: "" });
      handleSetMediaURL(img_url);
    } else if (contentType === VIDEO_UPLOAD) {
      const uploadTask = Firebase.uploadVideo(
        mediaContent,
        uploadFolder + "/videos"
      );
      setLoadingState({ loading: true, loading_script: UPLOADING_VIDEO });
      uploadTask.on(
        "state_changed",
        handleUploadProgress,
        handleUploadError,
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            setLoadingState({ loading: false, loading_script: "" });
            handleSetMediaURL(downloadURL);
          });
        }
      );
    } else if (contentType === YOUTUBE_URL) {
      this.handleSetMediaURL(mediaContent);
    }
  };

  const handleUploadProgress = (snapshot) => {
    var progress = (
      (snapshot.bytesTransferred / snapshot.totalBytes) *
      100
    ).toFixed(0);
    const loading_script = UPLOADING_VIDEO + " " + progress + "%";
    setLoadingState({ loading: loadingState.loading, loading_script });
  };

  const handleUploadError = (_error) => {
    setLoadingState({ loading: false, loading_script: "" });
  };

  return (
    <div className="edit-hotTopic col-div">
      <h4>Edit Hot Topic</h4>
      <p className="add-hotTopic-title">Title</p>
      <input
        className="form-control form-control-md form-control-alt"
        onChange={(e) => handleInputChange("title", e)}
        value={title}
      />
      <p className="add-hotTopic-title">Content Type</p>
      <div className="col-10 mb-2">
        <Select
          value={mediaType}
          onChange={handleSelectContentType}
          options={ContentTypes}
          isSearchable={false}
        ></Select>
      </div>
      {mediaType && (
        <div className="col-div mb-2">
          {mediaType.value === YOUTUBE_URL && (
            <YoutubeInput
              onChangeContent={uploadContent(YOUTUBE_URL)}
              currentUrl={mediaUrl}
            />
          )}
          {mediaType.value === IMAGE_UPLOAD && (
            <ImageUpload
              onChangeContent={uploadContent(IMAGE_UPLOAD)}
              contentUrl={mediaUrl}
            />
          )}
          {mediaType.value === GIF_UPLOAD && (
            <ImageUpload
              isGif={true}
              onChangeContent={uploadContent(GIF_UPLOAD)}
              contentUrl={mediaUrl}
            />
          )}
          {mediaType.value === VIDEO_UPLOAD && (
            <VideoUpload
              onChangeContent={uploadContent(VIDEO_UPLOAD)}
              defaultVideo={mediaUrl}
            />
          )}
        </div>
      )}
      <p className="add-hotTopic-title">Description</p>
      <textarea
        maxLength="280"
        className="form-control form-control-md form-control-alt"
        onChange={(e) => handleInputChange("description", e)}
        value={description}
      />
      <p className="bottom-small-text">Max characters: 280</p>

      {/* <p className="add-hotTopic-title">Tag</p>
      <input
        className="form-control form-control-md form-control-alt"
        onChange={(e) => handleInputChange("tag", e)}
        placeholder="@xxx"
        value={tag}
      /> */}
      <p className="add-hotTopic-title">Select Week</p>
      <MonthWeekSelect onSetWeek={setWeek} />
      <div className="user-access-categories">
        <p>Post to user access categories</p>
        <RadioItem
          menuName="Members"
          checked={toMembers}
          onYes={() => {
            setToMembers(true);
          }}
          onNo={() => {
            setToMembers(false);
          }}
        />
        <RadioItem
          menuName="Prospect"
          checked={toReferrals}
          onYes={() => {
            setToReferrals(true);
          }}
          onNo={() => {
            setToReferrals(false);
          }}
        />
      </div>
      <div className="add-hotTopic-footer">
        <button
          className="btn btn-white btn-brand-hex"
          style={{
            "--hover-text-color": state.white ? "white" : "black",
            "--hover-color": state.hex,
            backgroundColor: "white",
            color: "black",
          }}
          onClick={() => history.goBack()}
        >
          Cancel
        </button>
        <button
          className="btn btn-green"
          onClick={updateHotTopic}
          disabled={!checkValidation()}
        >
          Update
        </button>
        <button
          className="btn btn-white btn-brand-hex"
          style={{
            "--hover-text-color": state.white ? "white" : "black",
            "--hover-color": state.hex,
            backgroundColor: "white",
            color: "black",
          }}
          onClick={() => history.goBack()}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default EditHotTopic;



// WEBPACK FOOTER //
// ./src/screens/HotTopic/EditHotTopic/index.js